module.exports = __webpack_public_path__ + "static/media/heart-dark.b12dfe1f.svg";